<template>
  <v-navigation-drawer
    class="always-on-top"
    v-model="drawer"
    fixed
    temporary
    right
    @input="setDrawer"
  >
    <v-list nav dense>
      <v-subheader class="sub-header">
        <v-btn text small class="pa-0" color="primary">
          Arter
        </v-btn>
      </v-subheader>
      <v-list-item-group color="primary">
        <v-list-item
          link
          v-for="item in arterMenuPartOne"
          :key="item.name"
          @click="
            $router.push({
              name: item.url
            })
          "
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group :value="false">
          <template v-slot:activator>
            <v-list-item-title>Visa arter länsvis</v-list-item-title>
          </template>
          <v-list-item
            link
            v-for="item in arterMenuPartTwo"
            :key="item.name"
            class="ml-1"
            @click="setGeoArea(item.code)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list-item-group>
    </v-list>
    <v-list nav dense>
      <v-subheader class="sub-header">
        <v-btn
          text
          small
          class="pa-0"
          color="primary"
          @click="
            $router.push({
              name: 'Livsmiljoer'
            })
          "
        >
          Livsmiljöer
        </v-btn>
      </v-subheader>
      <v-list-item-group color="primary">
        <v-list-item
          link
          v-for="item in arterMenuPartThree"
          :key="item.name"
          @click="
            $router.push({
              name: item.url
            })
          "
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-list nav dense>
      <v-subheader class="sub-header">
        <v-btn
          text
          small
          class="pa-0"
          color="primary"
          @click="
            $router.push({
              name: 'Fakta'
            })
          "
        >
          Faktasidor
        </v-btn>
      </v-subheader>
      <v-list-item-group color="primary">
        <v-list-item
          link
          v-for="item in arterMenuPartFour"
          :key="item.name"
          @click="
            $router.push({
              name: item.url
            })
          "
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item link @click="goToOsersjon">
          <v-list-item-content>
            <v-list-item-title>Östersjöns historia</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list-item-group>
    </v-list>
    <v-list nav dense>
      <v-subheader class="sub-header">
        <v-btn
          text
          small
          class="pa-0"
          color="primary"
          @click="
            $router.push({
              name: 'om-livet'
            })
          "
        >
          Om livet i havet
        </v-btn>
      </v-subheader>
      <v-list-item-group color="primary">
        <v-list-item
          link
          v-for="item in arterMenuPartFive"
          :key="item.name"
          @click="
            $router.push({
              name: item.url
            })
          "
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'NavDrawer',
  data() {
    return {
      arterMenuPartOne: [
        { name: 'Visa alla arter', url: 'Species' },
        { name: 'Främmande arter', url: 'AlienSpecies' },
        { name: 'Rödlistade arter', url: 'RedSpecies' }
      ],
      arterMenuPartTwo: [
        { code: 'ab', name: 'Stockholms län' },
        { code: 'c', name: 'Uppsala län' },
        { code: 'd', name: 'Södermanlands län' },
        { code: 'e', name: 'Östergötlands län' },
        { code: 'h', name: 'Kalmar län' },
        { code: 'i', name: 'Gotlands län' },
        { code: 'm', name: 'Blekinge län' },
        { code: 'k', name: 'Skåne län' },
        { code: 'n', name: 'Hallands län' },
        { code: 'o', name: 'Västra Götalands län' },
        { code: 'x', name: 'Gävleborgs län' },
        { code: 'y', name: 'Västernorrlands län' },
        { code: 'ac', name: 'Västerbottens län' },
        { code: 'bd', name: 'Norrbottens län' }
      ],
      arterMenuPartThree: [
        {
          url: 'grunda-klipp-och-stenbottnar',
          name: 'Grunda klipp- och stenbottnar'
        },

        {
          url: 'djupa-klipp-och-stenbottnar',
          name: 'Djupa klipp- och stenbottnar'
        },

        { url: 'grunda-mjuka-bottnar', name: 'Grunda mjuka bottnar' },
        { url: 'djupa-mjuka-bottnar', name: 'Djupa mjuka bottnar' },
        { url: 'det-fria-vattnet', name: 'Det fria vattnet' }
      ],
      arterMenuPartFour: [
        { url: 'att-leva-i-havet', name: 'Att leva i havet' },
        { url: 'varken-salt-eller-sott', name: 'Salt och sött' },
        { url: 'vem-ater-vem', name: 'Vem äter vem' },
        { url: 'vem-lever-var', name: 'Vem lever var' }
        // { url: 'ostersjons-historia', name: 'Östersjöns historia' }
      ],
      arterMenuPartFive: [
        { url: 'quiz', name: 'Quiz' },
        { url: 'redaktion', name: 'Redaktion' },
        { url: 'medverkande-experter', name: 'Medverkande experter' },
        { url: 'engagera-dig', name: 'Engagera dig' }
        // { url: 'om-livet', name: 'Om livet i havet' },
        // { url: 'bestall-falthandbok', name: 'Beställ fälthandbok' },
        // { url: 'rapportera-fynd', name: 'Rapportera fynd' }
      ]
    }
  },
  computed: {
    drawer: {
      get() {
        return this.$store.state.navigationDrawer
      },
      set(e) {
        this.$store.dispatch('setNavigationdrawerVisibility', e)
      }
    }
  },
  methods: {
    goToOsersjon() {
      window.location = 'https://www.havet.nu/ostersjons-historia'
    },
    setDrawer(e) {},

    setGeoArea(strAreaCode) {
      this.isOpen = false
      this.$router.replace({ query: { area: strAreaCode } })
    }
  }
}
</script>

<style lang="scss" scoped>
.always-on-top {
  z-index: 9999999999 !important;
}
.sub-header {
  color: green !important;
  font-weight: 600;
  font-size: 0.8125rem;
  cursor: pointer;
}
</style>
